let uid = 0;
import countries from '@/config/countries.json';
let utils = {
    noop() {/* empty function */},
    getDID() {

    },
    getUid: function() {
        return uid++;
    },
    getScrollTop() {
        return document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    },
    getCookie(key) {
        let arr,
            reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");

        if(arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        }

        return null;
    },
    buildParams: function (data) {
        let i,
            params = [];
        for(i in data){
            if(data.hasOwnProperty(i)){
                params.push(`${i}=${data[i]}`);
            }
        }

        return params.join('&');
    },
    creatElement: function (tag, option, content) {
        let el = document.createElement(tag),
            i;
        for ( i in option) {
            if(option.hasOwnProperty(i)){
                el.setAttribute(i, option[i]);
            }
        }

        if(content){
            el.innerHTML = content;
        }
        return el;
    },
    getUid: function() {
        return uid++;
    },
    isURL: function(str) {
        // 暂时只需要判断以http://或https://开头的字符串，认定为链接
        return /^http(s)?:\/\//.test(str);
    },
    loadScript: function(xyUrl, async, callback){
        let head = document.getElementsByTagName('head')[0];
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = xyUrl;
        if(async) script.setAttribute('async', true);
        //借鉴了jQuery的script跨域方法
        script.onload = script.onreadystatechange = function(){
            if((!script.readyState || script.readyState === "loaded" || script.readyState === "complete")){
                callback && callback();
                // Handle memory leak in IE
                script.onload = script.onreadystatechange = null;
                if ( head && script.parentNode ) {
                    head.removeChild( script );
                }
            }
        };
        // Use insertBefore instead of appendChild  to circumvent an IE6 bug.
        head.insertBefore( script, head.firstChild );
    },
    jsonp: (function () {
        return function (url, success, fail, config) {
            let callback = 'jsonpCallback_' + utils.getUid(),
                jsonp = (config && config.jsonp) || 'callback',
                params = (config && config.data) ? '&' + utils.buildParams(config.data) : '',
                limeter = url.indexOf('?') + 1 ? '&' : '?',
                _url = url + limeter + jsonp + '=' + callback + params + '&_=' + Date.now(),
                s = this.creatElement("script", {"src": _url});
            window[callback] = function (data) {
                success && success(data);
                s.parentNode.removeChild(s);
                window[callback] = null;
            };
            document.getElementsByTagName('head')[0].appendChild(s);

            s.onerror = function() {
                fail && fail("ERROR");
                s.parentNode.removeChild(s);
                window[callback] = null;
            };

        };
    }()),
    setUid() {
        let s = [];
        let hexDigits = "0123456789abcdef";
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";

        let uid = s.join("");
        // document.cookie = ("news_uid=" + uid)
        let date = new Date();
        date.setTime(date.getTime() + 36500 * 24 * 60 * 60 * 1000); //设置date为当前时间加一百年

        document.cookie = `news_flow_uid=${uid}; path=/; expires=${date.toGMTString()}`;
        return uid;
    },
    loadRandomProbability() {
        let num;
        // 先随机1-100的随机整数
        let numdsf = Math.floor(Math.random()*(1 - 100) + 100);
        // 然后出现的随机数在1-50的概率为50%
        if(numdsf >=1 && numdsf<= 60){
            num = 1;
        }else if(numdsf >= 61&& numdsf <= 100){
            num = 2;
        }
        return num;
    },
    getQueryVariable(variable)  {
        let query = window.location.search.substring(1);
        let vars = query.split("&");
        for (let i=0; i<vars.length; i++) {
            let pair = vars[i].split("=");
            if(pair[0] == variable) { return pair[1];}
        }
        return(false);
    },
    loadLanguage() {
        let type = navigator.appName;
        let lang;
        if(type == "Netscape"){
            lang = navigator.language;//获取浏览器配置语言，支持非IE浏览器
        } else {
            lang = navigator.userLanguage;//获取浏览器配置语言，支持IE5+ == navigator.systemLanguage
        };
        lang = this.getQueryVariable('lang') || lang.substr(0, 2);//获取浏览器配置语言前两位
        return lang;
    },
    loadCountries() {
        let cty, lang = this.loadLanguage();
        countries.forEach((item, index) => {
            if(item.default_language === lang) {
                cty = item.iso_3166_2;
            }
        });
        return this.getQueryVariable('cty') || cty;
    },
    loadwaterfallCol() {
        let winWidth = document.body.clientWidth || document.documentElement.clientWidth,
            col = 3;
        if(winWidth < 900) col = 2;
        if(winWidth < 500) col = 1;
        return col;
    },
    uaType() {
        return  navigator.userAgent.toLowerCase().indexOf('mobile') > -1 ? 'mobile' : 'pc';
    }
};
//生成uid
if(document.cookie.indexOf('news_flow_uid') < 0) utils.setUid();

export default utils;



// WEBPACK FOOTER //
// ./src/utils/index.js